import { Stack, Typography } from '@mui/material'
import { LibraryCategoriesItem } from 'components/ui/dasboard-items/learn-library/LibraryCategoriesItem'
import { UICollapseProvider } from 'features/UI'
import React, { useMemo } from 'react'
import { ArticleCategory } from 'types'

export function CoursesList({ categoriesOfArticles }: { categoriesOfArticles: ArticleCategory[] }) {
  const firstPinnedCategoryId = useMemo(() => {
    const pinnedCategory = categoriesOfArticles.find((category) => category.isPinned)
    return pinnedCategory ? pinnedCategory.id : null
  }, [categoriesOfArticles])

  if (categoriesOfArticles.length === 0) {
    return (
      <Stack spacing={2}>
        <Typography variant="body1">No articles to read</Typography>
      </Stack>
    )
  }

  return (
    <Stack spacing={2}>
      <UICollapseProvider>
        {categoriesOfArticles.map((category: ArticleCategory) => {
          return (
            <LibraryCategoriesItem
              key={category.id}
              id={Number(category.id)}
              title={category.name}
              icon={category.icon}
              articles={category.articles}
              isFirstPinned={firstPinnedCategoryId === category.id}
              isPinned={category.isPinned}
            />
          )
        })}
      </UICollapseProvider>
    </Stack>
  )
}
